import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import { useFormik } from 'formik'
import { useEscuela } from 'hooks/useEscuela'
import { useToggle } from 'hooks/useToggle'
import React, { useState } from 'react'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from 'reactstrap'
import uuid from 'uuid/v4'
import * as yup from 'yup'
import PaginaPorDefecto from './Default'

const initialValues = {
  codigo: '',
  nombre: '',
  decano: '',
}

const escuelaSchema = yup.object().shape({
  codigo: yup.string().required('Este campo es requerido'),
  nombre: yup.string().required('Este campo es requerido'),
  decano: yup.string().required('Este campo es requerido'),
})

export default function Escuela() {
  const { open, onToggle } = useToggle()
  const [escuelaEdit, setEscuelaEdit] = useState(null)
  const [buscar, setBuscar] = useState('')
  const {
    obtenerEscuelas,
    handleEliminarEscuela,
    handleActualizarEscuela,
    handleCrearEscuela,
    handleBuscarEscuela,
  } = useEscuela(onToggle)
  const { data: escuelas } = obtenerEscuelas(buscar)

  const { handleChange, values, handleSubmit, errors } = useFormik({
    enableReinitialize: true,
    validationSchema: escuelaSchema,
    initialValues: {
      ...initialValues,
      ...escuelaEdit,
    },
    onSubmit: async (values, acciones) => {
      if (escuelaEdit) {
        handleActualizarEscuela({ values, acciones, id: escuelaEdit.id })
      } else {
        handleCrearEscuela(values, acciones)
      }
    },
  })

  const onClosedModal = () => {
    setEscuelaEdit(null)
  }

  return (
    <PaginaPorDefecto titulo='Escuela'>
      <Modal
        isOpen={open}
        toggle={onToggle}
        size='lg'
        unmountOnClose
        onClosed={onClosedModal}
      >
        <ModalHeader toggle={onToggle}>
          {escuelaEdit ? 'Editar' : 'Crear'} Escuela
        </ModalHeader>
        <ModalBody>
          <form className='form-horizontal col-xs-' onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Código</Label>
              <Input
                type='number'
                name='codigo'
                value={values.codigo}
                onChange={handleChange}
                placeholder='Ingrese codigo'
                invalid={!!errors.codigo}
              />
              <div className='invalid-feedback'>{errors.codigo}</div>
            </FormGroup>

            <FormGroup>
              <Label>Escuela</Label>
              <Input
                type='text'
                name='nombre'
                value={values.nombre}
                onChange={handleChange}
                placeholder='Ingrese nombre'
                invalid={!!errors.nombre}
              />
              <div className='invalid-feedback'>{errors.nombre}</div>
            </FormGroup>

            <FormGroup>
              <Label>Decano</Label>
              <Input
                type='text'
                name='decano'
                value={values.decano}
                onChange={handleChange}
                placeholder='Ingrese decano'
                invalid={!!errors.decano}
              />
              <div className='invalid-feedback'>{errors.decano}</div>
            </FormGroup>

            <div className='form-group'>
              <label
                className='col-md-12 control-label'
                htmlFor='singlebutton'
              ></label>
              <div className='col-md-12'>
                <Button className='mb-3' color='primary' type='submit'>
                  {escuelaEdit ? 'Editar' : 'Guardar'}
                </Button>
              </div>
            </div>
          </form>
        </ModalBody>
      </Modal>

      <TarjetaContenido
        titulo='Listar Escuela'
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarEscuela}
        />
        {escuelas ? (
          <Table responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Código</th>
                <th>Escuela</th>
                <th>Decano</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {escuelas.results.map((escuela, index) => (
                <tr key={uuid()}>
                  <th scope='row'>{index + 1}</th>
                  <td>{escuela.codigo}</td>
                  <td>{escuela.nombre}</td>
                  <td>{escuela.decano}</td>
                  <td className='d-flex'>
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      className='mr-1'
                      onClick={() => {
                        setEscuelaEdit(escuela)
                        onToggle()
                      }}
                    >
                      <FaPencilAlt />
                    </Button>{' '}
                    <Button
                      outline
                      color='danger'
                      size='sm'
                      onClick={() => handleEliminarEscuela(escuela)}
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div>Loading...</div>
        )}
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
